import React from 'react';
import { lazy } from 'react';
// project imports
import {Loadable} from 'components';
import {MinimalLayoutProvider} from 'components';
const AuthLogin = Loadable(lazy(() => import('pages/Login')));
const ForgotPassword = Loadable(lazy(() => import('pages/ForgotPassword')));
const ResetPassword= Loadable(lazy(()=>import('pages/ResetPassword')));

// ==============================|| AUTHENTICATION ROUTES ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayoutProvider />,
  children: [
    {
      path: '/Login',
      element: <AuthLogin />
    },
    {
      path: '/ForgotPassword',
      element: <ForgotPassword />
    },
    {
      path: '/ResetPassword',
      element: <ResetPassword />
    },
  ]
};

export default AuthenticationRoutes;
